export default "__VITE_ASSET__16lrNphQ__"